module.exports = __webpack_public_path__ + "img/OneLiner NoirBlanc.fbfd64d0.svg";